export default __webpack_public_path__ + "static/media/itap-favicon.a74bdc8d.ico";